import { arrayOf, bool, number, string, func, shape } from "prop-types";
import { PercentSettingContents } from "@tools";
import { Accordion, Button } from "@components";
import { BufferTitle } from "./BufferTitle";
import { Grid } from "@material-ui/core";
import { useTranslation } from "react-i18next";

export const NewBuffer = ({
  used,
  name,
  percent,
  workTypes,
  availableWorkTypes,
  onAccept,
  onChange,
  onCancel,
}) => {
  const { t } = useTranslation();
  
  const handleSetUsed = (newUsed) => {
    onChange({ used: newUsed })
  }
  
  const handleSetName = (newName) => {
    onChange({ name: newName })
  }
  
  const handleSetOf = (workTypes) => {
    onChange({ workTypes })
  }
  
  const handleSetPercent = (newPercent) => {
    onChange({ percent: newPercent })
  }
  
  return (
    <Accordion
      expanded
      title={<BufferTitle
        name={name}
        used={used}
        useActions={false}
        hasParent={Boolean(parent)}
        setUsed={handleSetUsed}
        setName={handleSetName}
      />}
      className="py-0-5"
      titleClassName="pl-2"
      variant="info"
      bordered={false}
      titleColored
    >
      <PercentSettingContents
        percent={percent}
        usedWorkTypes={workTypes}
        availableWorkTypes={availableWorkTypes}
        onPercentChange={handleSetPercent}
        onSelectWorkType={handleSetOf}
        hideWorkTypeList
        allowNegative
        allowSelectAllWorkTypes
        showPercentageWorkTypesTooltip
      />
      <Grid item container justifyContent="flex-end" className="mt-4">
        <Button
          variant="contained"
          color="secondary"
          onClick={onCancel}
          className="mr-2"
        >
          {t("common.cancel")}
        </Button>
        <Button
          variant="contained"
          color="primary"
          onClick={onAccept}
        >
          {t("common.apply")}
        </Button>
      </Grid>
    </Accordion>
  );
};

NewBuffer.propTypes = {
  used: bool.isRequired,
  name: string.isRequired,
  percent: number.isRequired,
  workTypes: arrayOf(number).isRequired,
  availableWorkTypes: arrayOf(shape({
    id: number.isRequired,
    name: string.isRequired,
    percentageWorkTypes: arrayOf(shape({
      id: number.isRequired,
      name: string,
    }))
  })),
  
  onChange: func.isRequired,
  onAccept: func.isRequired,
  onCancel: func.isRequired,
};